import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function JSTextTransform({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"default"} value={"none"}>
          Default (none)
        </MenuItem>,
        <MenuItem key={"capitalize"} value={"capitalize"}>
          Capitalize
        </MenuItem>,
        <MenuItem key={"uppercase"} value={"uppercase"}>
          Uppercase
        </MenuItem>,
        <MenuItem key={"lowercase"} value={"lowercase"}>
          Lowercase
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSTextTransformComponent: JSInputComponent = {
  Component: JSTextTransform,
  handlesCssProperties: ["textTransform"],
};
